export const ACTIVE_ORDERS_CALLCENTER = "ACTIVE_ORDERS_CALLCENTER";
export const ACTIVE_ORDERS_KITCHEN = "ACTIVE_ORDERS_KITCHEN";
export const ACTIVE_ORDERS_COURIER = "ACTIVE_ORDERS_COURIER";
export const UPDATE_FORM_SEARCH_ORDERS = "UPDATE_FORM_SEARCH_ORDERS";
export const UPDATE_STATUS_SEARCH = "UPDATE_STATUS_SEARCH";
export const UPDATE_LOAD_PAGE = "UPDATE_LOAD_PAGE";
export const UPDATE_FILTER_PAGE_KITCHEN = "UPDATE_FILTER_PAGE_KITCHEN";
